import { render, staticRenderFns } from "./GenerarEncuesta.vue?vue&type=template&id=48d490ea"
import script from "./GenerarEncuesta.vue?vue&type=script&lang=js"
export * from "./GenerarEncuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports